import React from 'react'
import CTAbutton from './CTAbutton';
import { FaArrowRight} from "react-icons/fa6";
import { TypeAnimation } from 'react-type-animation';


const CodeBlocks = ({position,heading,subHeading,ctaBtn1,ctaBtn2,codeblock,bgGradient,codeColor,backgroundGradient}) => {
  return (
    <div className={`flex ${position} flex-col my-20 justify-between items-ceter lg:gap-10 gap-10`}>

        {/* section 1 */}
        <div className='w-[100%] lg:w-[50%] flex flex-col gap-8'>
            {heading}
            
            <div className='text-richblack-300 text-base font-bold w-[85%] -mt-3'>
                {subHeading}
            </div>

            <div className='flex gap-7 mt-7'>
                <CTAbutton active={ctaBtn1.active} linkto={ctaBtn1.linkto} >
                    <div className='flex gap-2 items-center '>
                        {ctaBtn1.btnText}
                        <FaArrowRight/>
                    </div>
                </CTAbutton>

                <CTAbutton active={ctaBtn2.active} linkto={ctaBtn2.linkto} >
                    {ctaBtn2.btnText}
                </CTAbutton>
            </div>

        </div>

        {/* section 2 code wala */}
        <div className='h-fit code-border flex flex-row py-3 text-[10px] sm:text-sm leading-[18px] sm:leading-6 relative w-[100%] lg:w-[470px]'>
            
            {backgroundGradient}
            <div className='text-center flex flex-col w-[10%] text-richBlack-400 font-bold'>
                <p>1</p>
                <p>2</p>
                <p>3</p>
                <p>4</p>
                <p>5</p>
                <p>6</p>
                <p>7</p>
                <p>8</p>
                <p>9</p>
                <p>10</p>
                <p>11</p>
            </div>
            
            <div className={`flex flex-col w-[90%] gap-2 font-bold font-mono ${codeColor} pr-2`}>
                <TypeAnimation
                    sequence={[codeblock,2000,""]}
                    repeat={Infinity}
                    cursor={true}
                    style={
                        {
                            whiteSpace:"pre-line",
                            display:"block",
                        }
                    }
                    omitDeletionAnimation={true}
                />
            </div>


        </div>
    </div>
  )
}

export default CodeBlocks